
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.716 3.973l-.205 4.251a.975.975 0 01-.975.926h-.068a.975.975 0 01-.927-.975l.069-1.443-5.675 6.62a.976.976 0 01-.721.332.878.878 0 01-.732-.302l-4.65-4.924-6.543 4.973a.975.975 0 01-.594.195.974.974 0 01-.595-1.746l7.264-5.567a.975.975 0 011.306.107l4.505 4.778 5.09-5.938-1.59.244a.975.975 0 01-.263-1.93l4.212-.634a.975.975 0 01.8.243.975.975 0 01.292.79zm-1.248 16.643h-.975v-6.893a.975.975 0 00-1.95 0v6.893h-3.354v-2.993a.975.975 0 00-1.95 0v2.993H9.933v-6.893a.975.975 0 00-1.95 0v6.893H4.678v-3.968a.975.975 0 00-1.95 0v3.968H1.695a.975.975 0 100 1.95h19.773a.975.975 0 000-1.95z","fill":"#1D3C6F"}})])
          )
        }
      }
    